import { Route } from 'react-router-dom';

import { MerchantSettingsPage } from './MerchantSettingsPage.js';
export { MerchantSettingsPage as MerchantSettingsOverlay } from './MerchantSettingsPage.js';

export function settingsRoutes() {
  return (
    <>
      <Route path="/settings" element={<MerchantSettingsPage />} />
      <Route path="/settings/:tab" element={<MerchantSettingsPage />} />
    </>
  );
}
